import React, {useState} from 'react'
import "./Product.css"
import { useStateValue } from './StateProvider';
import 'font-awesome/css/font-awesome.min.css'; 



function Product({id, title, image, price, rating}) {
    const [{basket},dispatch] = useStateValue();
    const [love,setlove] = useState(true);
    

    const useHeart = (event) => {
        setlove(event.target.love = !love);
        
    }
    
    const addToBasket = () => {
        
dispatch({
    type: 'ADD_TO_BASKET',
    item:{
        id: id,
        title: title,
        image: image,
        price: price,
        rating: rating,
        
    
    },
});
 };
   
    return (
        <div className="product">
            <div classname="heart" onClick = {useHeart}><i className="fa fa-heart" style= {!love ? {color:'red'} :  {color:'grey'}}/></div>
            <img src={image} alt=""/>
            <div className= "product_info">
                <strong>{title}</strong>
                <p className= "product_price">
                    <small>$</small>
                    <span>{price}</span>
                </p>
                
            </div>
        <button className= "addToBasket" onClick= {addToBasket}><i class="fa fa-shopping-bag2x"/> Agregar al carrito</button>
        </div>
    );
}

export default Product
